import React, { Fragment, useState } from 'react'
import { Button, Col, Container, FormGroup, Row, Table, Input, ButtonGroup } from 'reactstrap'
import { useCashGlobal } from '../../hooks/cash/useCashGlobal'
import 'moment/locale/es';
import "react-datetime/css/react-datetime.css";
import './styleCash.css';
import { useCash } from '../../hooks/cash/useCash'
import { ModalReportCash } from './ModalReportCash';
import { ModalAuthorizationCash } from './ModalAuthorizationCash';
import { ToolTips } from '../../components/tooltips/ToolTips';
import { Dialog } from 'primereact/dialog';
import { Toast } from 'primereact/toast';
import { ConfigServer } from '../../data/config'


export const IndexReportGlobal = () => {

    let branchs = localStorage.getItem('branchName');
    const urlHelen = localStorage.getItem('url_helen');

    const {
        // ? CONFIGURATION
        _commercialLine, _nameUser, _branchName, _new, _admin_cash,

        // ? FORM 
        date1, date2, handleInputChange,

        // ? TYPE FORMAT
        formatter,

        // ? GLOBAL CASH
        dataAllGlobal, handleGetGlobalCash, amount1, loadingGlobal, amountTotal, amountCancell,

        // ? AUTHORIZATION CASH
        handleSearchAuthorization, selectedKey, toogleAuthorization, modalAuthorization, handleOpenPreview, handleClosedPreview, viewDetail, viewAmount, user, id_cash, saveCourtesyPatient,

        _type_client, _active_micro, _url_helen,

        // ? EXTEMPORANEOUS
        visibleTicket, showModalTicket, hideModalTicket, infoTicket, toast, userCapture,
        handleComment, handleAmount, formextemporaneus, createExtemporaneous, loadingExtemporaneous,




    } = useCashGlobal();

    const {
        //*CONFIGURATION CASH
        handleInputChangeCash, loading,


        //*FINAL REPORT
        dataReport, close, modalProps, totalPageCount1, currentPage1, nextPage1, previousPage1, goToPage1, dataPaymets, dataCancell,
        dataDiscount, dataPatient, mDateRange1, mDateRange2, getReport, mSelectBranch, handleSelectValuesCash,
        viewFormFilters, printCashClosing, branches, totalPaymets, exportToExcel, downloadExcel,

        //*FINAL REPORT TYPE COMPANY
        type_company, handleClean, dataMDiscount, dataUser, ids_users, modalFullRef, handleReport, total_devolution, printTicket,

        downloadExcelCredits, downloadExcelOthers, exportToExcelWithoutExams







    } = useCash();


    console.log("-----", dataReport.length);



    // #region CONFIGURATION TABLE
    // ? CONFIGURATIOM REPORT
    const [expandedRows, setExpandedRows] = useState({});
    const [expandedRows2, setExpandedRows2] = useState({});
    const [selectedRow, setSelectedRow] = useState(null);
    var _total_amount = 0;
    var _fech = "";



    // ? METHODS
    const toggleRow = (index) => {
        setExpandedRows((prev) => ({
            ...prev,
            [index]: !prev[index],
        }));
    };

    const toggleRow2 = (_key_user, _key_branch) => {
        const key = `${_key_user}-${_key_branch}`;

        setExpandedRows2((prevState) => {
            const newState = { ...prevState };

            if (newState[key]) {
                delete newState[key];
            } else {
                newState[key] = true;
            }

            return newState;
        });
    };

    const totalCaptureAmount = dataAllGlobal.reduce((total, _branch) => {
        return total + _branch?.detailBranches.reduce((branchTotal, _user) => {
            return branchTotal + _user.cash.reduce((userTotal, _detail) => {
                return userTotal + _detail?.captureAmount;
            }, 0);
        }, 0);
    }, 0);

    const handleRowSelect = (branchId) => {
        setSelectedRow(branchId);
    };
    // #endregion 



    // ? TABLE
    const totalAmountCash = (
        <tr>
            <td></td>
            <td style={{ height: '10px', textAlign: "end", fontWeight: "bold", fontSize: "11px" }}>Total Global</td>
            <td style={{ backgroundColor: '#013553', height: '10px', textAlign: "right", color: "#fff" }}>
                {formatter.format(amount1)}
            </td>
            <td style={{ backgroundColor: '#013553', height: '10px', textAlign: "right", color: "#fff" }}>
                {formatter.format(amountCancell)}
            </td>
            <td style={{ backgroundColor: '#013553', height: '10px', textAlign: "right", color: "#fff" }}>
                {formatter.format(amountTotal)}
            </td>
            <td style={{ backgroundColor: '#013553', height: '10px', textAlign: "right", color: "#fff" }}>
                {formatter.format(totalCaptureAmount)}
            </td>
        </tr>
    );

    const footerContent = <>
        <Button disabled={loadingExtemporaneous ? true : false} size="sm" outline color="secondary" type="button" onClick={() => createExtemporaneous(_fech)}  >{"Generar corte"}</Button>
        <Button disabled={loadingExtemporaneous ? true : false} size="sm" className="btn-air-light" outline color="danger" type="button" onClick={hideModalTicket}>Cancelar</Button>
    </>





    return (
        <Fragment>
            <div>
                <ModalReportCash
                    {...modalProps}
                    close={close}
                    data={dataReport}
                    branchs={branchs}
                    totalPageCount1={totalPageCount1}
                    currentPage1={currentPage1}
                    nextPage1={nextPage1}
                    previousPage1={previousPage1}
                    goToPage1={goToPage1}
                    dataPaymets={dataPaymets}
                    dataCancell={dataCancell}
                    dataDiscount={dataDiscount}
                    dataPatient={dataPatient}
                    mDateRange1={mDateRange1}
                    mDateRange2={mDateRange2}
                    handleInputChangeCash={handleInputChangeCash}
                    getReport={getReport}
                    loading={loading}
                    mSelectBranch={mSelectBranch}
                    handleSelectValuesCash={handleSelectValuesCash}
                    branches={branches}
                    formatter={formatter}
                    viewFormFilters={viewFormFilters}
                    printCashClosing={printCashClosing}
                    totalPaymets={totalPaymets}
                    exportToExcel={exportToExcel}
                    dataMDiscount={dataMDiscount}
                    handleClean={handleClean}
                    dataUser={dataUser}
                    ids_users={ids_users}
                    type_company={type_company}
                    total_devolution={total_devolution}
                    _active_micro={_active_micro}
                    _url_helen={_url_helen}
                    exportToExcelWithoutExams={exportToExcelWithoutExams}
                >
                </ModalReportCash>
            </div>
            <ModalAuthorizationCash
                {
                ...{
                    toogleAuthorization, modalAuthorization, _commercialLine, _nameUser,
                    _branchName, _new, handleOpenPreview, handleClosedPreview, viewDetail, viewAmount,
                    formatter, user, _admin_cash, id_cash, saveCourtesyPatient
                }
                }

            />
            {
                // ? DIALOG 
            }
            <Dialog visible={visibleTicket} style={{ width: '70vw' }} header={null} closable={false} onHide={hideModalTicket} footer={footerContent}>
                <Col sm="12">
                    {
                        loadingExtemporaneous &&
                        <>
                            <Row>
                                <Col sm="12" md="12" lg="12" className='text-center'>
                                    <img alt='modal-preview' src={require("../../assets/images/loginHelenLabs/HelenLabs.png")} className='fa-spin' style={{ width: "10%" }} />
                                </Col>
                                <Col sm="12" md="12" lg="12" className='text-center mt-1'>
                                    <p className='txt-secondary f-w-600 f-16' > Generando corte extemporaneo ...</p>
                                </Col>
                            </Row>
                        </>
                    }
                    <Row className={loadingExtemporaneous ? "d-none" : ""}  >
                        <Col sm="5" className='p-l-0 p-r-0' style={{ backgroundColor: "#fff" }}   >
                            <Col className="socialprofile filter-cards-view p-l-0 p-b-0 p-r-0">
                                {
                                    <>
                                        <Col sm="12"  >
                                            <div style={{ transform: 'scale(0.9)', transformOrigin: 'top left' }}>
                                                <Col sm="12" style={{ textAlign: "center" }} >
                                                    <img className="b-r-10" src={ConfigServer.serverUrl + "/api/Configuration/Logo"} style={{ width: "35%" }} alt="logo" />
                                                </Col>
                                                <Row>
                                                    <Col sm="12" className='p-l-0 p-r-0' style={{ textAlign: "center" }} >
                                                        <label className='f-14 f-w-600'>{_commercialLine} </label> <br />
                                                        <label style={{ fontSize: "11px" }} className=' f-w-600'>{_branchName} </label> <br />
                                                        <div className='preview-cash-div' ></div>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col sm="12" >
                                                        <Col sm="12" style={{ textAlign: "center" }}>
                                                            <label style={{ fontSize: "10px" }} >DETALLE</label>
                                                        </Col>
                                                        <div className="table-responsive">
                                                            <Table className='table-sm table-stripped' >
                                                                <thead>
                                                                    <tr style={{ backgroundColor: "#46AFE5" }}>
                                                                        <td colSpan={2} style={{ color: "#fff", textAlign: "center", fontSize: "14px" }} >Detalle</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <th style={{ color: "#000", textAlign: "center" }} > <label className='f-w-600 f-12'>Fecha de inicio</label></th>
                                                                        <th style={{ color: "#000", textAlign: "center" }} ><label className='f-w-600 f-12'>Fecha de corte</label></th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    <tr className='text-center f-w-500' style={{ fontSize: "11px" }}>
                                                                        <td>{_new ?? "---------"}</td>
                                                                        <td>{_new ?? "---------"}</td>
                                                                    </tr>
                                                                </tbody>
                                                            </Table>
                                                        </div>
                                                        <div className="table-responsive">
                                                            <Table className='table-sm table-stripped' >
                                                                <thead>
                                                                    <tr style={{ backgroundColor: "#46AFE5" }}>
                                                                        <td colSpan={2} style={{ color: "#fff", textAlign: "center", fontSize: "14px" }} >Detalle</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <th style={{ color: "#000", textAlign: "center" }} ><label className='f-w-600 f-12'>MÉTODO DE PAGO</label></th>
                                                                        <th style={{ color: "#000", textAlign: "center" }} ><label className='f-w-600 f-12'>TOTAL</label></th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {
                                                                        infoTicket.pay_methods && infoTicket.pay_methods.length > 0 && infoTicket.pay_methods.map((_obj, _key) => {
                                                                            _total_amount += _obj?.amount ?? 0
                                                                            let lastPayMethod = infoTicket.pay_methods?.[infoTicket.pay_methods.length - 1];
                                                                            _fech = lastPayMethod?.created_at ?? "---";
                                                                            let methodName;
                                                                            switch (_obj.id_pay_method) {
                                                                                case 1:
                                                                                    methodName = "Efectivo";
                                                                                    break;
                                                                                case 2:
                                                                                    methodName = "Tarjeta de Crédito";
                                                                                    break;
                                                                                case 4:
                                                                                    methodName = "Tarjeta de Débito";
                                                                                    break;
                                                                                case 8:
                                                                                    methodName = "Transferencia";
                                                                                    break;
                                                                                default:
                                                                                    methodName = "Crédito";
                                                                                    break;
                                                                            }
                                                                            return (
                                                                                <tr key={_key} className='text-center f-w-500' style={{ fontSize: "11px" }}>
                                                                                    <td>{methodName}</td>
                                                                                    <td>
                                                                                        <label className='f-12 f-w-600'>
                                                                                            {formatter.format(_obj.amount)}
                                                                                        </label>
                                                                                    </td>
                                                                                </tr>
                                                                            );
                                                                        })
                                                                    }

                                                                </tbody>
                                                            </Table>
                                                        </div>
                                                        <div className="table-responsive">
                                                            <Table className='table-sm table-stripped' >
                                                                <thead>
                                                                    <tr style={{ backgroundColor: "#46AFE5" }}>
                                                                        <td colSpan={2} style={{ color: "#fff", textAlign: "center", fontSize: "14px" }} >Detalle de movimientos</td>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    <tr>
                                                                        <td className='f-12'> <b className='f-12'>Total</b></td>
                                                                        <td className="text-center "><b className='f-12'>{formatter.format(_total_amount ?? 0)}</b></td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className='f-12'> <b className='f-12'>Efectivo registrado</b></td>
                                                                        <td className="text-center "><b className='f-12'> {formatter.format(formextemporaneus.amount ?? 0)}</b></td>
                                                                    </tr>
                                                                </tbody>
                                                            </Table>
                                                            <br />
                                                            <b htmlFor="">{formextemporaneus.comment ?? "--------"}</b>
                                                        </div> <br /> <br />
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col sm="12" className='p-l-0 p-r-0' style={{ textAlign: "center" }}>
                                                        <div className='preview-cash-div' ></div>
                                                        <label style={{ fontSize: "11px" }} className=' f-w-600'>{_nameUser} </label> <br />
                                                    </Col>
                                                </Row>
                                            </div>
                                        </Col>
                                    </>
                                }
                            </Col>
                        </Col>
                        <Col sm="6">
                            <label htmlFor="">Corte extemporaneo</label>
                            <div className=' p-1' >
                                <Row>
                                    <Col sm="12" md="12" lg="12">
                                        <label style={{ fontSize: "11px" }}>
                                            <i className="fa fa-circle text-info"></i>  Responsable de generar corte extemporaneo: <label className='txt-secondary f-w-600'>&nbsp;{_nameUser ?? "-----"}</label>
                                        </label>
                                    </Col>
                                    <Col sm="12" md="12" lg="12">
                                        <label style={{ fontSize: "11px" }}>
                                            <i className="fa fa-circle text-info"></i>  Usuario de caja: <label className='txt-secondary f-w-600'>&nbsp;{userCapture ?? "-----"}</label>
                                        </label>
                                    </Col>
                                    <Col sm="12" md="12" lg="12">
                                        <label style={{ fontSize: "11px" }}>
                                            <i className="fa fa-circle text-info"></i>  Fecha de corte del usuario: <label className='txt-secondary f-w-600'>&nbsp;{_fech ?? "-----"}</label>
                                        </label>
                                    </Col>

                                    <Col sm="12" md="12" lg="12">
                                        <label style={{ fontSize: "11px" }}>
                                            <i className="fa fa-circle text-info"></i>  Sucursal: <label className='txt-secondary f-w-600'>&nbsp;{branchs ?? "-----"}</label>
                                        </label>
                                    </Col>
                                    <Col sm="12" md="12" lg="12">
                                        <label style={{ fontSize: "11px" }}>
                                            <i className="fa fa-circle text-info "></i>  Monto a reportar en caja: <label className='f-w-600 f-12'></label>
                                        </label>
                                    </Col>
                                    <Col sm="12" md="12" lg="12">
                                        <label style={{ fontSize: "11px" }}>
                                            <i className="fa fa-circle text-info"></i>  Efectivo: <input value={formextemporaneus.amount} onChange={handleAmount} type="number" className='inputCash f-12' placeholder='Ingrese la cantidad' name="capture_amount" />
                                        </label>
                                    </Col>
                                    <Col sm="12" md="12" lg="12">
                                        <label style={{ fontSize: "11px" }}>
                                            <i className="fa fa-circle text-info"></i>  Oberservaciones:
                                        </label>
                                        <textarea
                                            className='form-control form-control-sm input-air-primary'
                                            name="comments"
                                            rows="3"
                                            value={formextemporaneus.comment}
                                            onChange={handleComment}
                                            style={{ fontSize: "12px" }}
                                        >
                                        </textarea>
                                    </Col>
                                </Row>
                            </div>

                        </Col>
                    </Row>
                </Col>

            </Dialog>



        </Fragment>


    )
}


